import { render } from "./EntrenadoresList.vue?vue&type=template&id=7addd88c&scoped=true"
import script from "./EntrenadoresList.vue?vue&type=script&lang=js"
export * from "./EntrenadoresList.vue?vue&type=script&lang=js"

import "./EntrenadoresList.vue?vue&type=style&index=0&id=7addd88c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7addd88c"]])

export default __exports__